import { Modal, Form, Button } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import DatePiker from "../../datepiker/datePiker";
import useAxios from "../../../services/useAxios";
import AuthenticationContext from "../../../Authentication/AuthenticationContext.ts";
import { CustomInput, ReactSelect } from "../../kits/Inputs/Inputs";

import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../../utils/swal";
import Select from "react-select";

export default function ManagementNote({ show, setShow, selectedContact }) {
  const { userInfo } = useContext(AuthenticationContext);
  const [text, setText] = useState("");

  const handleClose = () => setShow(false);
  const { execute: SendMessage } = useAxios("api/chat_send_message");

  const sendHandler = (text) => {
    if (text == "") {
      showSwalError("متن خالی است");
      return;
    }
    SendMessage({
      sender_id: userInfo["id"],
      receiver_id: selectedContact?.id,
      text: text,
      is_admin_note: 1,
      customer_id: selectedContact?.customer_id,
    }).then((result) => {
      if (result["status"] == 1) {
        setText("");
        setShow(false);
        // showSwalSuccess("ارسال شد");
      } else {
        setText("");
        showSwalError("لطفا دوباره امتحان کنید");
      }
    });
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> یادداشت مدیریتی</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomInput
            label={"یادداشت مدیریتی"}
            placeholder={"یادداشت"}
            inputType="textarea"
            type="text"
            labelClassName="text-dark fs-6"
            onChangeFunc={(e) => setText(e.target.value)}
            inputValue={text}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            لغو
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              sendHandler(text);
            }}
          >
            ارسال
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
